import React, { useEffect, useMemo, useRef, useState } from "react";
import EmojiPicker from "emoji-picker-react";
import { useNavigate } from "react-router-dom";
import "./RespostasRapidas.css";

export default function RespostasRapidas() {
  const [lista, setLista] = useState([]);
  const [busca, setBusca] = useState("");
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState("");
  const [form, setForm] = useState({ id: null, atalho: "/novo", titulo: "", conteudo: "" });
  const navigate = useNavigate();
    const tituloRef = useRef(null);
    const conteudoRef = useRef(null);
    const [pickerAberto, setPickerAberto] = useState(null);
    const [mostrarPicker, setMostrarPicker] = useState(false);


      const inserirNoCursor = (ref, valor) => {
   const el = ref?.current;
    if (!el) return;
    const start = el.selectionStart ?? el.value.length;
    const end = el.selectionEnd ?? el.value.length;
    const texto = el.value;
    const novo = texto.slice(0, start) + valor + texto.slice(end);
    el.value = novo;
    // atualiza form de acordo com o campo
    if (ref === tituloRef) setForm((f) => ({ ...f, titulo: novo }));
    if (ref === conteudoRef) setForm((f) => ({ ...f, conteudo: novo }));
    // reposiciona o caret
    const pos = start + valor.length;
    requestAnimationFrame(() => {
      el.focus();
      el.setSelectionRange(pos, pos);
    });
  };


  const load = async (q = "") => {
    setLoading(true);
    setErro("");
    try {
      const res = await fetch(
        `/crm-wly/api/whatsapp/respostas_rapidas.php${q ? `?q=${encodeURIComponent(q)}` : ""}`,
        { credentials: "include" }
      );
      const data = await res.json();
      if (data?.success && Array.isArray(data.data)) setLista(data.data);
      else throw new Error(data?.error || "Falha ao listar");
    } catch (e) {
      setErro(e.message);
      setLista([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const editar = (r) => setForm({ id: r.id, atalho: r.atalho, titulo: r.titulo, conteudo: r.conteudo });
  const cancelarEdicao = () => setForm({ id: null, atalho: "/novo", titulo: "", conteudo: "" });

  useEffect(() => { setPickerAberto(null); }, [form.id]);

  const salvar = async () => {
    setErro("");
    if (!form.atalho?.startsWith("/") || !form.titulo?.trim() || !form.conteudo?.trim()) {
      setErro("Preencha atalho iniciando com '/', título e conteúdo.");
      return;
    }
    setSalvando(true);
    try {
      const res = await fetch("/crm-wly/api/whatsapp/respostas_rapidas.php", {
        method: form.id ? "PUT" : "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("Erro ao salvar (atalho duplicado?)");
      cancelarEdicao();
      await load(busca);
    } catch (e) {
      setErro(e.message);
    } finally {
      setSalvando(false);
    }
  };

  const excluir = async (id) => {
    if (!window.confirm("Excluir esta resposta rápida?")) return;
    setErro("");
    try {
      const res = await fetch("/crm-wly/api/whatsapp/respostas_rapidas.php", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ id }),
      });
      if (!res.ok) throw new Error("Erro ao excluir");
      await load(busca);
    } catch (e) {
      setErro(e.message);
    }
  };

  const preview = useMemo(
    () => (form.conteudo || "").slice(0, 120) + ((form.conteudo || "").length > 120 ? "…" : ""),
    [form.conteudo]
  );

  return (
    <div className="rr-titulo">
        <h1>Respostas Rápidas</h1>

        <div className="rr-container">
      <div className="rr-header">
                <div className="rr-actions">
          <button className="btn-voltar-rr"  onClick={() => navigate('/wzp/painel-mensagens')}>
            ← Voltar ao Chat
          </button>
        </div>
      </div>

      <div className="rr-toolbar">
        <input
          className="rr-input"
          placeholder="Buscar por atalho ou título…"
          value={busca}
          onChange={(e) => setBusca(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && load(busca)}
        />
        <button className="rr-primary" onClick={() => load(busca)}>Buscar</button>
        <button className="rr-limpar" onClick={() => { setBusca(""); load(""); }}>Limpar</button>
      </div>

      <div className="rr-editor">
        <div className="rr-row">
          <div className="rr-col">
            <label>Atalho *</label>
            <input
              className="rr-input"
              placeholder="/atalho"
              value={form.atalho}
              onChange={(e) => setForm({ ...form, atalho: e.target.value })}
            />
          </div>
          <div className="rr-col">
            <label>Título *</label>
            <div style={{ position: "relative" }}>
           <input
              className="rr-input"
              placeholder="Ex.: Apresentação"
              value={form.titulo}
              ref={tituloRef}
              onChange={(e) => setForm({ ...form, titulo: e.target.value })}
            />    
            </div>
          </div>
        </div>

         <div style={{ position: "relative" }}>
          <textarea
            className="rr-textarea"
            rows={5}
            placeholder="Mensagem completa que será inserida no chat…"
            value={form.conteudo}
            onChange={(e) => setForm({ ...form, conteudo: e.target.value })}
            style={{ paddingBottom: "35px" }} // espaço p/ botão
          />
          <button
            type="button"
            className="rr-emoji-btn"
            title="Inserir emoji"
            onClick={() => setMostrarPicker((v) => !v)}
            style={{
              position: "absolute",
              bottom: "5px",
              right: "10px",
              background: "transparent",
              border: "none",
              fontSize: "20px",
              cursor: "pointer",
            }}
          >
            😊
          </button>
          {mostrarPicker && (
            <div
              style={{
                position: "absolute",
                bottom: "45px",
                right: 0,
                zIndex: 1000,
              }}
            >
              <EmojiPicker
                onEmojiClick={(emoji) =>
                  setForm((f) => ({ ...f, conteudo: f.conteudo + emoji.emoji }))
                }
                autoFocusSearch={false}
                theme="light"
              />
            </div>
          )}
        </div>

        <div className="rr-editor-footer">
          <div className="rr-preview">
            <span>Prévia:</span>
            <p>{preview || "—"}</p>
          </div>
          <div className="rr-editor-buttons">
            {form.id && (
              <button className="rr-secondary" onClick={cancelarEdicao}>
                Cancelar
              </button>
            )}
            <button className="rr-primary" disabled={salvando} onClick={salvar}>
              {salvando ? "Salvando…" : form.id ? "Atualizar" : "Salvar"}
            </button>
          </div>
        </div>

        {erro && <div className="rr-error">{erro}</div>}
      </div>

      <div className="rr-list">
        {loading ? (
          <div className="rr-loading">Carregando…</div>
        ) : (
          <>
            {lista.length === 0 ? (
              <div className="rr-empty">Nenhuma resposta rápida encontrada.</div>
            ) : (
              <table className="rr-table">
                <thead>
                  <tr>
                    <th style={{ width: 140 }}>Atalho</th>
                    <th style={{ width: 260 }}>Título</th>
                    <th>Conteúdo</th>
                    <th style={{ width: 140, textAlign: "center" }}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {lista.map((r) => (
                    <tr key={r.id}>
                      <td>{r.atalho}</td>
                      <td>{r.titulo}</td>
                      <td className="rr-conteudo">{r.conteudo}</td>
                      <td className="rr-acoes">
                        <button className="rr-editar" onClick={() => editar(r)}>Editar</button>
                        <button className="rr-danger" onClick={() => excluir(r.id)}>Excluir</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        )}
      </div>
    </div>
    </div>
  );
}
